import { Link } from "react-router-dom";
import { siteInfo, testimonials, categories } from "@/mocks/articles";
import SEOHead from "@/components/feature/SEOHead";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-950">
      <SEOHead
        title="关于我们 - 吃瓜黑料在线 | 品牌介绍与联系方式"
        description="了解吃瓜黑料在线的品牌故事、团队背景和核心价值。我们致力于为吃瓜群众提供最快、最全、最真实的娱乐八卦资讯。查看联系方式与常见问题。"
        keywords="吃瓜黑料在线介绍,关于吃瓜黑料,吃瓜黑料联系方式,吃瓜黑料品牌,黑料平台介绍"
        canonicalUrl="https://www.chiguaheiliaozx.com/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于吃瓜黑料在线",
            url: "https://www.chiguaheiliaozx.com/about",
            description: "了解吃瓜黑料在线的品牌故事、团队背景和核心价值。",
            isPartOf: { "@type": "WebSite", name: "吃瓜黑料在线", url: "https://www.chiguaheiliaozx.com" },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://www.chiguaheiliaozx.com" },
              { "@type": "ListItem", position: 2, name: "关于我们" },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqList.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: { "@type": "Answer", text: faq.answer },
            })),
          }),
        }}
      />
      {/* About Hero */}
      <section className="relative w-full h-[280px] md:h-[380px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20elegant%20composition%20with%20warm%20gold%20and%20deep%20burgundy%20accents%2C%20cinematic%20atmosphere%2C%20mysterious%20luxurious%20texture%2C%20high%20contrast%2C%20artistic%20noir%20aesthetic%2C%20professional%20editorial%20style%2C%20deep%20shadows%2C%20ambient%20dramatic%20lighting&width=1920&height=800&seq=about-hero&orientation=landscape"
          alt="关于吃瓜黑料在线"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-background-950"></div>

        <div className="absolute inset-0 flex items-center">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-3">
              <nav className="flex items-center gap-1.5 text-xs text-foreground-500">
                <Link
                  to="/"
                  className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  首页
                </Link>
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-foreground-600"></i>
                </div>
                <span className="text-foreground-300 whitespace-nowrap">
                  关于我们
                </span>
              </nav>
            </div>
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary-500/20 border border-primary-500/30 rounded-full mb-4">
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">
                品牌介绍
              </span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mb-3">
              关于吃瓜黑料在线
            </h1>
            <p className="text-sm text-foreground-400 max-w-xl">
              {siteInfo.tagline} · 每日不间断追踪网络热点事件
            </p>
          </div>
        </div>
      </section>

      {/* Brand Introduction - About Module */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="flex flex-col lg:flex-row gap-10 items-center">
          <div className="lg:w-2/5">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20office%20scene%20with%20multiple%20computer%20monitors%20displaying%20news%20feeds%2C%20cinematic%20lighting%2C%20professional%20workspace%2C%20dramatic%20shadows%2C%20high%20contrast%2C%20artistic%20composition%2C%20noir%20aesthetic%2C%20mysterious%20atmosphere%2C%20warm%20accent%20lights&width=800&height=1000&seq=about-brand&orientation=portrait"
                alt="吃瓜黑料在线编辑部"
                className="w-full object-cover object-top"
              />
              <div className="absolute top-4 left-4">
                <span className="px-2.5 py-1 bg-background-950/70 border border-background-600/50 text-foreground-300 text-xs rounded-full whitespace-nowrap">
                  成立于 {siteInfo.founded}
                </span>
              </div>
            </div>
          </div>
          <div className="lg:w-3/5">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50 mb-4">
              全网最快的吃瓜第一站
            </h2>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              吃瓜黑料在线成立于{siteInfo.founded}年，是国内领先的娱乐八卦资讯聚合平台。我们拥有一支{siteInfo.stats.teamSize}专业编辑团队，全天候追踪网络热点事件，致力于为吃瓜群众提供最快、最全、最真实的娱乐八卦资讯。
            </p>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              我们坚持「有实锤才发」的报道原则，每一条爆料都经过多方交叉验证。对于未经证实的传闻，我们会明确标注信息来源和可信度，让用户能够理性吃瓜、明辨是非。
            </p>
            <p className="text-sm text-foreground-400 leading-relaxed mb-6">
              从网红塌房到明星爆料，从直播翻车到娱乐圈内幕，从综艺八卦到电竞吃瓜——我们覆盖{siteInfo.stats.categories}内容领域，累计发布超过{siteInfo.stats.totalArticles}条爆料资讯，日均访问量突破{siteInfo.stats.dailyVisitors}，是广大吃瓜群众最信赖的八卦资讯平台。
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Stats Grid */}
      <section className="w-full bg-background-900/70 py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50 mb-8 text-center">
            数据一览
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            <div className="text-center p-5 bg-background-950 border border-background-700 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 bg-primary-500/10 rounded-full">
                <i className="ri-user-line text-primary-500 text-lg"></i>
              </div>
              <div className="font-heading text-2xl font-bold text-foreground-50 mb-1">
                {siteInfo.stats.dailyVisitors}
              </div>
              <div className="text-xs text-foreground-500">日均访问量</div>
            </div>
            <div className="text-center p-5 bg-background-950 border border-background-700 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 bg-accent-500/10 rounded-full">
                <i className="ri-article-line text-accent-500 text-lg"></i>
              </div>
              <div className="font-heading text-2xl font-bold text-foreground-50 mb-1">
                {siteInfo.stats.totalArticles}
              </div>
              <div className="text-xs text-foreground-500">累计发布</div>
            </div>
            <div className="text-center p-5 bg-background-950 border border-background-700 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 bg-secondary-500/10 rounded-full">
                <i className="ri-time-line text-secondary-500 text-lg"></i>
              </div>
              <div className="font-heading text-2xl font-bold text-foreground-50 mb-1">
                {siteInfo.stats.updateFrequency}
              </div>
              <div className="text-xs text-foreground-500">更新频率</div>
            </div>
            <div className="text-center p-5 bg-background-950 border border-background-700 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 bg-primary-500/10 rounded-full">
                <i className="ri-stack-line text-primary-500 text-lg"></i>
              </div>
              <div className="font-heading text-2xl font-bold text-foreground-50 mb-1">
                {siteInfo.stats.categories}领域
              </div>
              <div className="text-xs text-foreground-500">内容覆盖</div>
            </div>
            <div className="text-center p-5 bg-background-950 border border-background-700 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 bg-accent-500/10 rounded-full">
                <i className="ri-team-line text-accent-500 text-lg"></i>
              </div>
              <div className="font-heading text-2xl font-bold text-foreground-50 mb-1">
                {siteInfo.stats.teamSize}
              </div>
              <div className="text-xs text-foreground-500">编辑团队</div>
            </div>
          </div>
        </div>
      </section>

      {/* Reputation - Testimonials */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 bg-accent-500/10 border border-accent-500/20 text-accent-400 text-xs rounded-full font-medium mb-3 whitespace-nowrap">
            用户口碑
          </span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50 mb-2">
            吃瓜群众怎么说
          </h2>
          <p className="text-sm text-foreground-500">
            你的吃瓜体验，是我们最在乎的事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-900 border border-background-700 rounded-lg p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-50">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-600">
                    {t.username}
                  </div>
                </div>
              </div>
              <p className="text-xs text-foreground-400 leading-relaxed">
                &ldquo;{t.comment}&rdquo;
              </p>
              <div className="flex items-center gap-0.5 mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact CTA */}
      <section className="relative w-full py-20 md:py-24 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20artistic%20composition%20with%20flowing%20golden%20and%20crimson%20gradients%2C%20cinematic%20atmosphere%2C%20luxurious%20texture%2C%20high%20contrast%2C%20mysterious%20elegant%20vibe%2C%20professional%20editorial%20aesthetic%2C%20ambient%20dramatic%20lighting&width=1920&height=800&seq=contact-cta&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-lg">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-4">
              联系我们
            </h2>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6">
              有猛料想爆料？有合作想洽谈？有任何问题想咨询？欢迎通过以下方式联系我们。
            </p>
            <div className="flex flex-col gap-3 mb-8">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/20 rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-primary-500"></i>
                </div>
                <span className="text-sm text-foreground-300">
                  {siteInfo.email}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/20 rounded-full flex-shrink-0">
                  <i className="ri-weibo-line text-primary-500"></i>
                </div>
                <span className="text-sm text-foreground-300">
                  {siteInfo.weibo}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/20 rounded-full flex-shrink-0">
                  <i className="ri-wechat-line text-primary-500"></i>
                </div>
                <span className="text-sm text-foreground-300">
                  微信公众号：{siteInfo.wechat}
                </span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-50 text-background-950 rounded-full text-sm font-semibold hover:bg-foreground-200 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-apple-fill"></i>
                </div>
                iOS 下载
              </button>
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-50/10 border border-foreground-50/30 text-foreground-50 rounded-full text-sm font-semibold hover:bg-foreground-50/20 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-android-line"></i>
                </div>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50 mb-8">
          常见问题
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqList.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-900 border border-background-700 rounded-lg overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
                <h4 className="text-sm font-semibold text-foreground-50 pr-4">
                  {faq.question}
                </h4>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-4 pb-4">
                <p className="text-xs text-foreground-400 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </section>
    </div>
  );
}

const faqList = [
  {
    question: "吃瓜黑料在线的爆料信息可信吗？",
    answer: "我们坚持「有实锤才发」的原则。每一条爆料都会经过多方交叉验证，标注信息来源和可信度等级。对于未经证实的传闻，我们会明确标注「待核实」标签，让用户理性判断。",
  },
  {
    question: "如何第一时间收到最新爆料推送？",
    answer: "您可以通过关注我们的官方社交媒体账号、下载官方APP（即将上线）或收藏本站并开启浏览器通知来获取最新爆料推送。我们承诺：重大爆料发生后5分钟内推送。",
  },
  {
    question: "被爆料的内容可以要求删除吗？",
    answer: "如果爆料内容存在事实错误，我们会在核实后立即更正或撤稿。但如果爆料内容属实且涉及公众利益，我们将依法保留报道权利。任何删稿请求请通过官方邮箱提交书面材料和证据。",
  },
  {
    question: "吃瓜黑料在线有APP吗？",
    answer: "我们的APP正在紧锣密鼓地开发中，预计将于近期上线各大应用商店。届时将提供更流畅的阅读体验、更及时的推送通知和独家爆料内容。敬请期待！",
  },
  {
    question: "如何投稿爆料？",
    answer: "欢迎知情人士向我们投稿爆料！请将相关资料发送至我们的官方邮箱 tips@chiguaheiliaozx.com，我们承诺对投稿人信息绝对保密。对于重大独家爆料，我们将提供丰厚稿酬。",
  },
  {
    question: "网站的更新频率是怎样的？",
    answer: "我们的编辑团队7×24小时不间断追踪网络热点事件。重大事件发生后，通常在5-15分钟内即可发布第一手报道。日常更新频率约为每小时2-3条内容，确保您不错过任何大瓜。",
  },
];